type directionType = "column" | "row";
type alignItemsType = "center" | "flex-start";

type jutifyContentType = "center" | "space-between";

export function flex(
  direction: directionType = "row",
  alignItems?: alignItemsType,
  justifyContent?: jutifyContentType
) {
  return `
    align-items:${alignItems || null};
    display:flex;
    flex-direction:${direction};
    justify-content:${justifyContent || null};
  `;
}

export const alignX = `
  left:50%;
  transform:translateX(-50%);
`;

export const alignXAndY = `
  left:50%;
  top:50%;
  transform:translate(-50%, -50%);
`;

export const darkEffect = `
  &:hover {
    cursor:pointer;
    filter:brightness(98%);
  }

  &:active {
    filter:brightness(95%);
  }
`;

export const opacityEffect = `
  &:hover {
    cursor:pointer;
    opacity:.9;
  }

  &:active {
    opacity:.7;
  }
`;

export const modalZIndex = 9999;

export const breakpoints = {
  tablet: "1024px",
};
